import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useUpdateContact = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onUpdateContactError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      'Something went wrong while updating the contact.',
    );
  };

  const onUpdateContactSuccess = (callbackFn?: () => void) => ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success(message);
    if (callbackFn) {
      callbackFn();
    }
  };

  const updateContact = (data: any, id: string, email: string, callbackFn?: () => void) => {
    const url: HttpConfig = {
      url: `api/v1/contacts/${id}`,
      method: 'put',
      data: { name: data.contactInfo, email },
    };
    request(url, onUpdateContactSuccess(callbackFn), setLoading, onUpdateContactError);
  };

  return { updateContact, loading };
};

export default useUpdateContact;
